<template>
  <v-container>
    <v-card class="px-2">
      <input id="user-id" type="hidden" v-model="processo.usuario">
      <input id="proc-uuid" type="hidden" v-model="processo.uuid">
      <v-row>
        <v-col cols="12" md="4" lg="2">
          <v-text-field v-model="codigo" label="Código" dense outlined @change="loadProcesso()">
            <v-icon slot="append" color="success" large @click="loadDialog">
              mdi-magnify
            </v-icon>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3" lg="2" v-if="codigo">
          <v-checkbox v-model="processo.inativar" label="Inativar processo?" color="success"
            v-show="mode === 'save'"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3" lg="2">
          <v-checkbox v-model="processo.covid19" label="Atender ao Covid-19?" color="success" class="mt-0"
            v-show="mode === 'save'"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3" lg="2" v-if="codigo">
          <v-checkbox v-model="processo.bloquear" label="Bloquear processo?" color="success"
            v-show="mode === 'save'"></v-checkbox>
        </v-col>
      </v-row>
      <v-row class="mb-2">
        <v-col colls="12" lg="2" md="4" sm="12" v-if="!codigo">
          <v-text-field label="Processo de compra:" v-model="processo.proc_compra" required
            :readonly="mode === 'remove'" dense outlined>
          </v-text-field>
        </v-col>
        <v-col colls="12" lg="2" md="4" sm="12">
          <v-card-text class="py-0 mt-0">Número licitação.:<h4>{{ nr_licita }}</h4>
          </v-card-text>
        </v-col>
        <v-col colls="12" lg="2" md="4" sm="12">
          <v-card-text class="py-0 mt-0">Valor estimado.:<h4>{{ val_licita }}</h4>
          </v-card-text>
        </v-col>
        <v-col colls="12" lg="2" md="4" sm="12">
          <v-card-text class="py-0 mt-0">Homologado ?<h4>{{ homologa }}</h4>
          </v-card-text>
        </v-col>
        <v-col colls="12" lg="2" md="4" sm="12">
          <v-card-text class="py-0 mt-0">Data Homologação.:<h4>{{ dt_homologa }}</h4>
          </v-card-text>
        </v-col>
        <v-col colls="12" lg="2" md="4" sm="12">
          <v-card-text class="py-0 mt-0">Situação do processo.:<h4>{{ situacao }}</h4>
          </v-card-text>
        </v-col>
      </v-row>
      <v-card flat>
        <v-tabs background-color="primary" dark v-model="tabs" class="mb-4">
          <v-tab>
            <v-icon class="mr-1">
              mdi-info-square-fill
            </v-icon>
            Informações gerais
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">
              mdi-cog-sync
            </v-icon>
            Carga
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">
              mdi-hammer
            </v-icon>
            Licitação
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">
              mdi-account-multiple-plus-outline
            </v-icon>
            Conc./Seletivos
          </v-tab>
          <v-tab @click="loadDispensa">
            <v-icon class="mr-1">
              mdi-folder-symlink
            </v-icon>
            Dispensa/Inexigibilidade
          </v-tab>
          <v-tab @click.prevent="loadCredenciamentos">
            <v-icon class="mr-1">
              mdi-account-multiple-plus-outline
            </v-icon>
            Credenciamento
          </v-tab>
          <v-tab @click="loadHomologacao">
            <v-icon class="mr-1">
              mdi-clipboard
            </v-icon>
            Homologação/outros
          </v-tab>
          <v-tab @click="loadAnexos">
            <v-icon class="mr-1">
              mdi-paperclip
            </v-icon>
            Anexos
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  <v-card flat class="py-2">
                    <v-row>
                      <v-col colls="12" lg="4" md="6" sm="12">
                        <v-autocomplete v-model="processo.uid_gestao" :items="gestao" v-if="mode === 'save'"
                          label="Gestão de compra:" dense outlined clearable>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="2" md="6" sm="12">
                        <v-text-field label="Ano da licitação :" v-model="processo.ano" required
                          :readonly="mode === 'remove'" dense outlined clearable>
                        </v-text-field>
                      </v-col>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Modalidade:" v-model="processo.uid_modal"
                          :items="modalidade" dense outlined clearable>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Tipo de julgamento:" v-model="processo.uid_tipo"
                          :items="tipo" dense outlined clearable>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12">
                        <v-text-field v-model="processo.titulo" label="Título" rows="3" dense outlined clearable
                          hint="* Usado somente em seletivos, credenciamentos ou chamada pública"
                          persistent-hint></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12">
                        <v-textarea v-model="processo.objetivo" label="Objetivo do licitacao :" rows="3" dense outlined
                          clearable placeholder="Descição para o licitacao..."></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="6" md="6" sm="12">
                        <v-text-field label="Solicitante :" v-model="processo.solicitante" required
                          :readonly="mode === 'remove'" dense outlined clearable>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" lg="2" md="6" sm="12">
                        <v-menu v-model="menu8" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datproc" v-model="data_proc" label="Data.:" dense outlined
                              @blur="mudaDataI">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date8" @input="dateI">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="2" md="6" sm="12">
                        <v-text-field label="Processo protocolo :" v-model="processo.processo" required
                          :readonly="mode === 'remove'" dense outlined clearable>
                        </v-text-field>
                      </v-col>
                      <v-col colls="12" lg="2" md="6" sm="12">
                        <v-autocomplete v-model="processo.continuado" :items="continuado" v-if="mode === 'save'"
                          label="Serviço continuado:" dense outlined clearable>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="3" md="4" sm="12">
                        <v-autocomplete v-model="processo.tp_participacao" :items="tp_participacao"
                          v-if="mode === 'save'" label="Tipo de participação:" dense outlined clearable>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" lg="5">
                        <v-checkbox v-model="processo.base_lei1397920" label="Processo com base na Lei 13.979/20?"
                          color="success"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  Carregar dados da API Prodata
                  <v-card>
                    <v-container>
                      <v-form>
                        <v-row>
                          <v-col cols="12" md="6" lg="2">
                            <v-menu v-model="menu9" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-mask="datp" v-model="data_ini" label="Data inicial.:" dense outlined
                                  @blur="mudaDataJ">
                                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker locale="pt-br" v-model="date9" @input="dateJ">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-menu v-model="menu10" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-mask="datp" v-model="data_fim" label="Data final.:" dense outlined
                                  @blur="mudaDataK">
                                  <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                    mdi-calendar
                                  </v-icon>
                                </v-text-field>
                              </template>
                              <v-date-picker locale="pt-br" v-model="date10" @input="dateK">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-text-field v-model="sync.codigo" label="Número do processo.:" dense outlined />
                          </v-col>
                          <v-col cols="12" md="6" lg="2">
                            <v-text-field v-model="sync.codigo_modalidade" label="Modalidade.:" dense outlined />
                          </v-col>
                        </v-row>
                        <v-row class="mt-1">
                          <v-col cols="12" md="6">
                            <v-btn color="success" class="ml-1 mr-4" @click="syncDados">
                              <v-icon left>
                                mdi-table-sync
                              </v-icon>
                              Carregar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  <v-card flat class="py-2">
                    <v-row>
                      <v-col colls="12" lg="2" md="6" sm="12">
                        <v-text-field label="Nº da licitacao :" v-model="processo.licitacao" required
                          :readonly="mode === 'remove'" dense outlined clearable>
                        </v-text-field>
                      </v-col>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datab" v-model="data_abe" label="Data de abertura.:" dense outlined
                              @blur="mudaDataC">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date2" @input="dateC">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-text-field label="Hora Início :" class="mb-2" type="time" v-model="processo.hora_inicio"
                          :readonly="mode === 'remove'" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="3" md="3" sm="12">
                        <v-currency-field v-if="mode === 'save'" label="Valor estimado :" dense outlined
                          v-model="processo.valor">
                        </v-currency-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  <v-card flat class="py-2">
                    <v-row>
                      <v-col colls="12" lg="4" md="8" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Parecer Jurídico:"
                          v-model="processo.parecer_juridico" :items="juridico" clearable dense outlined>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="2" md="4" sm="12">
                        <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datpj" v-model="data_pjur" label="Data Parecer Jurídico.:" dense
                              outlined @blur="mudaDataD">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date3" @input="dateD">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="4" md="8" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Parecer Controle Interno:"
                          v-model="processo.parecer_controle_interno" :items="controle" clearable dense outlined>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="2" md="4" sm="12">
                        <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datpc" v-model="data_pcint" label="Data Parecer Cont. Interno.:" dense
                              outlined @blur="mudaDataE">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date4" @input="dateE">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="4" md="4" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Tipo de Ação:" v-model="processo.uid_tipo_acao"
                          :items="acao" dense clearable outlined>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="4" md="4" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Tipo de Processo:"
                          v-model="processo.uid_tipo_processo" :items="tpprocesso" dense clearable outlined>
                        </v-autocomplete>
                      </v-col>
                      <v-col colls="12" lg="4" md="4" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Outro veículo de publicação:"
                          v-model="processo.uid_veiculo_publicacao" :items="veiculo" dense clearable outlined>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="3" md="4" sm="12">
                        <v-menu v-model="menu5" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datlc" v-model="data_lcred" label="Data limite para credenciamento.:"
                              dense outlined @blur="mudaDataF">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date5" @input="dateF">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="2" md="3" sm="12">
                        <v-text-field label="Das.:" class="mb-2" type="time" v-model="processo.encerram_hora_inicio"
                          :readonly="mode === 'remove'" dense outlined>
                        </v-text-field>
                      </v-col>
                      <v-col colls="12" lg="2" md="3" sm="12">
                        <v-text-field label="às.:" class="mb-2" type="time" v-model="processo.encerram_hora_fim"
                          :readonly="mode === 'remove'" dense outlined>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="12" md="12" sm="12">
                        <v-textarea v-model="processo.ds_razao_escolha_fornecedor"
                          label="Razão da escolha do fornecedor/prestador.:" rows="2" dense outlined></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="py-2">
              <v-data-table :headers="headersCred" :items="fornecedores" :search="search">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon medium color="primary" class="mr-2" @click="loadFornec(item)">
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon medium color="error" class="mr-2" @click="loadFornec(item, 'removef')">
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-row>
                <v-col cols="12" md="6">
                  <v-btn color="success" class="ml-1 mb-3" v-if="codigo" @click="AddFornecedor">
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Add fornecedor
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  <v-card flat class="py-2">
                    <v-row>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="datp" v-model="data_pub" label="Data de publicacao.:" dense outlined
                              @blur="mudaDataA">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date" @input="datePub">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="2" md="4" sm="12">
                        <v-checkbox label="Publicar no site?" v-show="mode === 'save'" color="success"
                          v-model="processo.publicar">
                        </v-checkbox>
                      </v-col>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-mask="dath" v-model="data_hom" label="Data de Homologação.:" dense outlined
                              @blur="mudaDataB">
                              <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="date1" @input="dateB">
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col colls="12" lg="2" md="4" sm="12">
                        <v-checkbox label="Homologar processo?" v-show="mode === 'save'" color="success"
                          v-model="processo.homologado" class="mt-4 mb-2">
                        </v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col colls="12" lg="3" md="6" sm="12">
                        <v-autocomplete v-if="mode === 'save'" label="Situação do processo:"
                          v-model="processo.uid_situacao" :items="tpsituacao" clearable dense outlined>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col cols="12" md="12">
                  <v-card flat class="py-2">
                    <v-data-table :headers="headerAnexo" :items="anexos" :search="search">
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon medium color="primary" class="mr-2" @click="loadAnexo(item, 'update')">
                          mdi-square-edit-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-card-actions class="justify-end">
                      <v-btn color="success" class="ml-1 mb-3" v-if="codigo" @click="loadModalAnexo">
                        <v-icon left>
                          mdi-archive-arrow-up-outline
                        </v-icon>
                        Add anexo
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-row class="mt-1">
            <v-col cols="12" md="6">
              <v-btn color="success" class="ml-1 mr-4" v-if="mode === 'save'" @click="save">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn color="error" class="mr-4" v-if="mode === 'remove'" @click="remove">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Deletar
              </v-btn>
              <v-btn color="secondary" class="mr-4" @click="reset">
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <!-- Modal para formulario de anexo-->
      <v-container>
        <v-dialog v-model="DialogAnexo" transition="dialog-top-transition">
          <v-card tile>
            <v-toolbar color="primary" dark class="mb-2">
              Adicionar anexos ao processo
            </v-toolbar>
            <div class="logo-foto ml-4 mt-5">
              <v-form>
                <input id="user-id" type="hidden" v-model="anexo.usuario" />
                <input id="anexo-id" type="hidden" v-model="anexo.id" />
                <v-row>
                  <v-col cols="12" md="4" lg="3">
                    <v-text-field v-model="anexo.nome" type="text" label="Nome do arquivo" outlined dense>
                    </v-text-field>
                  </v-col>
                  <v-col colls="12" lg="3" md="4">
                    <v-autocomplete label="Tipo de documento:" v-model="anexo.uid_cat_doc" :items="anexos" dense
                      outlined>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="5" lg="4">
                    <v-menu v-model="menu6" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-mask="datanex" v-model="data_anex" label="Data de publicacao.:" dense outlined
                          @blur="mudaDataG">
                          <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                            mdi-calendar
                          </v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker locale="pt-br" v-model="date6" @input="dateG">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col colls="12" lg="3" md="4">
                    <v-checkbox v-model="anexo.inativar" label="Inativar ítem?" color="success"
                      v-show="mode === 'update'" class="mt-4">
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <template>
                    <!-- <v-file-input
                      accept="application/vnd.ms-excel, application/pdf"
                      label="Arquivo"
                      placeholder="Pick an avatar"
                      outlined
                      append-icon
                      append-outer-icon="mdi-folder-upload"
                      type="file"
                      ref="file"
                      small-chips
                      @change="selectFile()"
                    ></v-file-input> -->
                    <v-file-input accept="application/vnd.ms-excel, application/pdf" label="Arquivo" outlined
                      append-outer-icon="mdi-folder-upload" small-chips @change="selectFile" />
                  </template>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn v-show="mode === 'save'" color="success" class="mr-4" v-if="codigo" type="submit"
                @click.prevent="fileUpload()">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn v-show="mode === 'save'" color="error" class="mr-4" v-if="codigo" @click="clearUpload">
                Remover
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn color="danger" class="mr-4" @click="FecharDialog">
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="DialogFornecedor" transition="dialog-top-transition">
          <v-card tile min-height="500">
            <v-toolbar color="primary" dark class="mb-2">
              <v-icon>
                mdi-pencil-box-outline
              </v-icon>Adicionar Fornecedor
              <v-spacer></v-spacer>

              <v-btn icon @click="fechaDialogFornecedor">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form class="altura px-2 py-2">
              <input id="user-id" type="hidden" v-model="fornecedor.usuario" />
              <input id="fornecedor-uid" type="hidden" v-model="fornecedor.uid_processo" />
              <input id="fornecedor-id" type="hidden" v-model="fornecedor.id" />
              <v-row>
                <v-col cols="12" md="3" lg="2" class="mr-0 pr-0">
                  <v-text-field class="codigo mr-0" v-model="fornecedor.uid_pessoa" label="Código..." dense outlined
                    flat @change="loadPedidoPessoaId()">
                    <v-icon class="v-icon-btn-outer" slot="append-outer" color="white" large @click="loadFtPessoa">
                      mdi-magnify
                    </v-icon>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="5" class="mx-0 px-0">
                  <v-text-field class="v-busca-nome ml-0" v-model="fornecedor.razao" :loading="loading"
                    aria-autocomplete="none" :search-input.sync="search" label="Nome/ Razão social" outlined dense
                    @keyup.native="loadSeach()">
                    <v-icon slot="prepend" color="white" @click="loadAddPessoa" class="v-icon-btn" large>
                      mdi-plus
                    </v-icon>
                    <v-icon v-if="fornecedor.razao" slot="append" color="black" @click.prevent="clPessoa">
                      mdi-close
                    </v-icon>
                  </v-text-field>
                  <v-card v-show="listar === 'sim'" class="my-0 py-0">
                    <ul class="filtro">
                      <li v-for="item in items" :key="item.uid_pessoa">
                        <a @click="loadPedidoPessoaId(item, 'novo')"> {{ item.razao }} - {{ item.cgc_txt }}</a>
                      </li>
                    </ul>
                  </v-card>
                </v-col>
                <v-col cols="12" md="5" lg="3">
                  <v-menu v-model="menu7" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-mask="datacred" v-model="data_cred" label="Data do credênciamento.:" dense
                        outlined @blur="mudaDataH">
                        <v-icon slot="append" color="success" large v-bind="attrs" v-on="on">
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="date7" @input="dateH">
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions class="justify-center">
              <v-btn color="success" class="mr-4" v-if="codigo" type="submit" @click="adicionarfornecedor">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e limpar
              </v-btn>
              <v-btn color="success" class="mr-4" v-if="codigo" type="submit" @click="adicionarfornecedorSair">
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Adicionar e sair
              </v-btn>
              <v-btn color="error" class="mr-4" v-if="codigo" @click="limpar">
                Limpar
                <v-icon left>
                  mdi-broom
                </v-icon>
              </v-btn>
              <v-btn color="danger" class="mr-4" @click="fechaDialogFornecedor">
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog v-model="dialogFilter" transition="dialog-bottom-transition" fullscreen>
          <template v-slot:default="dialogFilter">
            <v-card>
              <v-toolbar color="primary" dark>
                Pesquisar Processos
              </v-toolbar>
              <v-card-title>
                <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
                  hide-details>
                </v-text-field>
              </v-card-title>
              <v-data-table :headers="headerProc" :items="proc" :search="search">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon medium color="primary" class="mr-2" @click="loadProcesso(item)">
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon medium color="error" class="mr-2" @click="loadProcesso(item, 'remove')">
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn color="error" @click="dialogFilter.value = false">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'Proc-compra',
  computed: mapState(['user']),

  data: function () {
    return {
      errors: {},
      datp: '##/##/####',
      dath: '##/##/####',
      datlc: '##/##/####',
      datpc: '##/##/####',
      datpj: '##/##/####',
      datab: '##/##/####',
      datanex: '##/##/####',
      datacred: '##/##/####',
      datproc: '##/##/####',
      mode: 'save',
      tabs: null,
      codigo: '',
      dialogFilter: false,
      DialogAnexo: false,
      DialogFornecedor: false,
      date: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      date4: new Date().toISOString().substr(0, 10),
      date5: new Date().toISOString().substr(0, 10),
      date6: new Date().toISOString().substr(0, 10),
      date7: new Date().toISOString().substr(0, 10),
      date8: new Date().toISOString().substr(0, 10),
      date9: new Date().toISOString().substr(0, 10),
      date10: new Date().toISOString().substr(0, 10),
      data_abe: '',
      data_pub: '',
      data_hom: '',
      data_pjur: '',
      data_pcint: '',
      data_lcred: '',
      data_anex: '',
      data_cred: '',
      data_proc: '',
      data_ini: '',
      data_fim: '',
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      menu9: false,
      menu10: false,
      search: null,
      uuid: '',
      uploadReady: true,
      // file: '',
      file: null,
      arquivo: '',
      tabela: 'licitanexos',
      uuid_anexo: '',
      publicacao: '',
      nr_licita: '[N. Informado]',
      val_licita: '[N. Informado]',
      homologa: '[N. Informado]',
      dt_homologa: '[N. Informado]',
      situacao: '[N. Informado]',
      juridico: [],
      controle: [],
      acao: [],
      tpprocesso: [],
      veiculo: [],
      tpsituacao: [],
      processo: {},
      sync: {},
      tipo: [],
      modalidade: [],
      anexo: {},
      anexos: [],
      gestao: [],
      loading: false,
      select: null,
      fornecedor: {},
      fornecedores: [],
      busca: '',
      items: [],
      listar: '',
      filter: null,
      filterOn: [],
      proc: [],
      headerProc: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Processo compra', value: 'proc_compra' },
        { text: 'Processo', value: 'processo' },
        { text: 'Gestao', value: 'gestao' },
        { text: 'Licitacao', value: 'licitacao' },
        { text: 'Ano', value: 'ano', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headersCred: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Cod. fornecedor', value: 'uid_pessoa' },
        { text: 'Nome / Razão social', value: 'razao' },
        { text: 'CNPJ', value: 'cgc_txt' },
        { text: 'Data do cadastro', value: 'data' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      headerAnexo: [
        {
          text: 'Cód',
          align: 'start',
          sortable: false,
          value: 'id'
        },
        { text: 'Processo comp', value: 'uid_processo' },
        { text: 'Nome do arquivo', value: 'nome' },
        { text: 'Url', value: 'url' },
        { text: 'Tamanho', value: 'size' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      continuado: [
        { text: 'Não', value: 2 },
        { text: 'Sim', value: 1 }
      ],
      tp_participacao: [
        { text: 'Compras', value: 1 },
        { text: 'Serviços', value: 2 },
        { text: 'Edital', value: 3 },
        { text: 'Aviso de contratação direta', value: 4 }
      ]
    }
  },

  methods: {
    mudaDataA () {
      const [dia, mes, ano] = this.data_pub.split('/')
      if (this.data_pub) {
        this.processo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    datePub () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
      const [dia, mes, ano] = this.data_pub.split('/')
      this.contrato.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataB () {
      const [dia, mes, ano] = this.data_hom.split('/')
      if (this.data_hom) {
        this.processo.data_homologacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateB () {
      this.data_hom = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
      const [dia, mes, ano] = this.data_hom.split('/')
      this.processo.data_homologacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataC () {
      const [dia, mes, ano] = this.data_abe.split('/')
      if (this.data_abe) {
        this.processo.data_abertura = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateC () {
      this.data_abe = moment(this.date2).format('DD/MM/YYYY')
      this.menu2 = false
      const [dia, mes, ano] = this.data_abe.split('/')
      this.processo.data_abertura = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataD () {
      const [dia, mes, ano] = this.data_pjur.split('/')
      if (this.data_pjur) {
        this.processo.data_parecer_juridico = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateD () {
      this.data_pjur = moment(this.date3).format('DD/MM/YYYY')
      this.menu3 = false
      const [dia, mes, ano] = this.data_pjur.split('/')
      this.processo.data_parecer_juridico = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataE () {
      const [dia, mes, ano] = this.data_pcint.split('/')
      if (this.data_pcint) {
        this.processo.data_parecer_controle_interno = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateE () {
      this.data_pcint = moment(this.date4).format('DD/MM/YYYY')
      this.menu4 = false
      const [dia, mes, ano] = this.data_pcint.split('/')
      this.processo.data_parecer_controle_interno = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataF () {
      const [dia, mes, ano] = this.data_lcred.split('/')
      if (this.data_lcred) {
        this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateF () {
      this.data_lcred = moment(this.date5).format('DD/MM/YYYY')
      this.menu5 = false
      const [dia, mes, ano] = this.data_lcred.split('/')
      this.processo.data_encerramento = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataG () {
      const [dia, mes, ano] = this.data_anex.split('/')
      if (this.data_anex) {
        this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateG () {
      this.data_anex = moment(this.date6).format('DD/MM/YYYY')
      this.menu6 = false
      const [dia, mes, ano] = this.data_anex.split('/')
      this.anexo.data_publicacao = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataH () {
      const [dia, mes, ano] = this.data_cred.split('/')
      if (this.data_cred) {
        this.fornecedor.data_cadastro = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateH () {
      this.data_cred = moment(this.date7).format('DD/MM/YYYY')
      this.menu7 = false
      const [dia, mes, ano] = this.data_cred.split('/')
      this.fornecedor.data_cadastro = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataI () {
      const [dia, mes, ano] = this.data_proc.split('/')
      if (this.data_proc) {
        this.processo.data_processo = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateI () {
      this.data_proc = moment(this.date8).format('DD/MM/YYYY')
      this.menu8 = false
      const [dia, mes, ano] = this.data_proc.split('/')
      this.processo.data_processo = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataJ () {
      const [dia, mes, ano] = this.data_ini.split('/')
      if (this.data_ini) {
        this.sync.dataInicial = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateJ () {
      this.data_ini = moment(this.date9).format('DD/MM/YYYY')
      this.menu9 = false
      const [dia, mes, ano] = this.data_ini.split('/')
      this.sync.dataInicial = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    mudaDataK () {
      const [dia, mes, ano] = this.data_fim.split('/')
      if (this.data_fim) {
        this.sync.dataFinal = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
      }
    },
    dateK () {
      this.data_fim = moment(this.date10).format('DD/MM/YYYY')
      this.menu10 = false
      const [dia, mes, ano] = this.data_fim.split('/')
      this.sync.dataFinal = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    // selectFile () {
    //   this.file = this.$refs.file.files[0]
    // },
    // async fileUpload () {
    //   const formData = new FormData()
    //   const method = this.anexo.id ? 'put' : 'post'
    //   const id = this.anexo.id ? `/${this.anexo.id}` : ''
    //   const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
    //   formData.append('uid_processo', this.processo.proc_compra)
    //   formData.append('nome', this.anexo.nome)
    //   formData.append('tabela', this.tabela)
    //   formData.append('pasta', this.processo.ano)
    //   formData.append('subpasta', this.processo.proc_compra)
    //   formData.append('uid_cat_doc', this.anexo.uid_cat_doc)
    //   formData.append('data_publicacao', this.anexo.data_publicacao)
    //   formData.append('usuario', this.user.id)
    //   formData.append('file', this.file)
    //   await axios[method](url, formData)
    //     .then(() => {
    //       this.$toasted.global.defaultSuccess()
    //       this.resetUpload()
    //       this.loadAnexos()
    //     })
    //     .catch(showError)
    // },
    selectFile (fileList) {
      this.file = fileList // `fileList` já vem como o arquivo selecionado
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`

      formData.append('uid_processo', this.processo.proc_compra)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.processo.ano)
      formData.append('subpasta', this.processo.proc_compra)
      formData.append('uid_cat_doc', this.anexo.uid_cat_doc)
      formData.append('data_publicacao', this.anexo.data_publicacao)
      formData.append('usuario', this.user.id)
      formData.append('file', this.file)

      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
          this.loadAnexos()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    clearUpCampos () {
      this.anexo = {}
      this.file = ''
    },
    resetUpload () {
      this.anexo = {}
      this.file = ''
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    reset () {
      this.mode = 'save'
      this.processo = {}
      this.sync = {}
      this.anexos = []
      this.codigo = ''
      this.nr_licita = '[N. Informado]'
      this.val_licita = '[N. Informado]'
      this.homologa = '[N. Informado]'
      this.dt_homologa = '[N. Informado]'
      this.situacao = '[N. Informado]'
      this.data_pub = ''
      this.data_hom = ''
      this.data_abe = ''
      this.data_pjur = ''
      this.data_pcint = ''
      this.data_lcred = ''
      this.data_anex = ''
      this.data_proc = ''
      this.data_ini = ''
      this.data_fim = ''
      this.processo.uuid = uuid.v1()
    },
    limpar () {
      this.fornecedor = {}
      this.data_cred = ''
      this.mode = 'save'
    },
    resetModal () {
      this.loadFilter()
    },
    loadDialog () {
      this.codigo = ''
      this.dialogFilter = true
      this.loadFilter()
    },
    loadModal () {
      this.loadFilter()
      this.$refs['ed-processos'].show()
    },
    hideModal () {
      this.loadFilter()
      this.$refs['ed-processos'].hide()
    },
    FecharDialog () {
      this.DialogAnexo = false
      this.limpar()
    },
    loadModalAnexo () {
      this.uuid_anexo = uuid.v1()
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadFilter () {
      const url = `${baseApiUrl}/tc-licitacoes-filtro`
      axios.get(url).then(res => {
        this.proc = res.data
      })
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    save () {
      const method = this.processo.id ? 'put' : 'post'
      const id = this.processo.id ? `/${this.processo.id}` : ''
      axios[method](`${baseApiUrl}/tc-licitacoes${id}`, this.processo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },

    syncDados () {
      //  this.sync.contribuinte = this.divida.contribuinte
      //  this.sync.dataIncial = this.date0
      //  this.sync.dataFinal = this.date2
      const method = 'post'
      axios[method](`${baseApiUrl}/carga-prodata-licitacoes-sync`, this.sync)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },

    saveFornec () {
      const method = this.fornecedor.id ? 'put' : 'post'
      const id = this.fornecedor.id ? `/${this.fornecedor.id}` : ''
      axios[method](`${baseApiUrl}/vencedores${id}`, this.fornecedor)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
        })
        .catch(showError)
    },
    loadCredenciamentos () {
      const id = this.processo.proc_compra
      const url = `${baseApiUrl}/vencedores-do-processo/${id}`
      axios.get(url).then(res => {
        this.fornecedores = res.data.map(item => {
          return {
            ...item,
            data: moment(item.data_cadastro).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadPedidoPessoaId (item) {
      const id = this.fornecedor.uid_pessoa ? `/${this.fornecedor.uid_pessoa}` : `/${item.uid_pessoa}`
      const url = `${baseApiUrl}/pessoas-por-idd${id}`
      axios.get(url).then(res => {
        this.fornecedor = res.data
        this.fornecedor.uid_processo = this.processo.proc_compra
        this.fornecedor.usuario = this.user.id
      })
      this.clPessoa()
    },
    clPessoa () {
      this.fornecedor = {}
      this.items = []
      this.listar = ''
    },
    loadSeach (listar = 'sim') {
      const search = this.fornecedor.razao || 0
      const url = `${baseApiUrl}/pessoas-por-nome/${search}`
      axios.get(url).then(res => {
        this.items = res.data
      })
      this.listar = listar
    },
    adicionarfornecedor () {
      this.saveFornec()
    },
    adicionarfornecedorSair () {
      this.saveFornec()
      this.DialogFornecedor = false
    },
    loadAddPessoa () {

    },
    loadFtPessoa () {

    },
    AddFornecedor () {
      this.DialogFornecedor = true
    },
    fechaDialogFornecedor () {
      this.DialogFornecedor = false
      this.listar = ''
      this.items = []
      this.fornecedor = {}
    },
    loadFornec (fornec, mode = 'save') {

    },
    loadProcesso (proc, mode = 'save') {
      const id = this.codigo ? this.codigo : proc.proc_compra
      const url = `${baseApiUrl}/tc-licitacoes/${id}`
      axios.get(url).then(res => {
        this.processo = res.data
        this.nr_licita = this.processo.licitacao
        this.codigo = this.processo.proc_compra
        this.situacao = this.processo.situacao
        this.val_licita = this.processo.valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
        if (!this.processo.data_processo) {
          this.data_proc = ''
        } else {
          this.data_proc = moment(this.processo.data_processo).format('DD/MM/YYYY')
          this.processo.data_processo = moment(this.processo.data_processo).format('YYYY-MM-DD')
        }
        if (!this.processo.data_abertura) {
          this.data_abe = ''
        } else {
          this.data_abe = moment(this.processo.data_abertura).format('DD/MM/YYYY')
          this.processo.data_abertura = moment(this.processo.data_abertura).format('YYYY-MM-DD')
        }
        if (!this.processo.data_publicacao) {
          this.data_pub = ''
        } else {
          this.data_pub = moment(this.processo.data_publicacao).format('DD/MM/YYYY')
          this.processo.data_publicacao = moment(this.processo.data_publicacao).format('YYYY-MM-DD')
        }
        if (!this.processo.data_homologacao) {
          this.data_hom = ''
        } else {
          this.data_hom = moment(this.processo.data_homologacao).format('DD/MM/YYYY')
          this.processo.data_homologacao = moment(this.processo.data_homologacao).format('YYYY-MM-DD')
        }
        if (!this.processo.data_parecer_juridico) {
          this.data_pjur = ''
        } else {
          this.data_pjur = moment(this.processo.data_parecer_juridico).format('DD/MM/YYYY')
          this.processo.data_parecer_juridico = moment(this.processo.data_parecer_juridico).format('YYYY-MM-DD')
        }
        if (!this.processo.data_parecer_controle_interno) {
          this.data_pcint = ''
        } else {
          this.data_pcint = moment(this.processo.data_parecer_controle_interno).format('DD/MM/YYYY')
          this.processo.data_parecer_controle_interno = moment(this.processo.data_parecer_controle_interno).format('YYYY-MM-DD')
        }
        if (!this.processo.data_encerramento) {
          this.data_lcred = ''
        } else {
          this.data_lcred = moment(this.processo.data_encerramento).format('DD/MM/YYYY')
          this.processo.data_encerramento = moment(this.processo.data_encerramento).format('YYYY-MM-DD')
        }
        if (this.processo.homologado === 1) {
          this.homologa = 'Sim'
          this.dt_homologa = moment(this.processo.data_homologacao).format('DD/MM/YYYY')
        }
        this.loadAnexos()
      })
      this.mode = mode
      this.dialogFilter = false
    },
    loadGestoes () {
      const url = `${baseApiUrl}/gestoes`
      axios.get(url).then(res => {
        this.gestao = res.data.map(gestao => {
          return { value: gestao.id, text: `${gestao.id} - ${gestao.gestao}` }
        })
      })
    },
    loadTipoAnexo () {
      const url = `${baseApiUrl}/categoria-de-documentos`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            value: item.id,
            text: `${item.cat_doc}`
          }
        })
      })
    },
    loadTipo () {
      const url = `${baseApiUrl}/tipo-modalidade`
      axios.get(url).then(res => {
        this.tipo = res.data.map(tipo => {
          return {
            value: tipo.id,
            text: `${tipo.tipo}`
          }
        })
      })
    },
    loadModalidade () {
      const url = `${baseApiUrl}/modalidades`
      axios.get(url).then(res => {
        this.modalidade = res.data.map(modalidade => {
          return {
            value: modalidade.id,
            text: `${modalidade.modalidade}`
          }
        })
      })
    },
    loadModalAcao () {
      const url = `${baseApiUrl}/modal-tipo-acao`
      axios.get(url).then(res => {
        this.acao = res.data.map(acao => {
          return {
            value: acao.id,
            text: `${acao.modalidade}`
          }
        })
      })
    },
    loadModalProcesso () {
      const url = `${baseApiUrl}/modal-tipo-processo`
      axios.get(url).then(res => {
        this.tpprocesso = res.data.map(tpprocesso => {
          return {
            value: tpprocesso.id,
            text: `${tpprocesso.modalidade}`
          }
        })
      })
    },
    loadVeiculo () {
      const url = `${baseApiUrl}/veiculo-de-publicacao`
      axios.get(url).then(res => {
        this.veiculo = res.data.map(veiculo => {
          return {
            value: veiculo.id,
            text: `${veiculo.veiculo_publicacao}`
          }
        })
      })
    },
    loadSituacao () {
      const url = `${baseApiUrl}/situacoes`
      axios.get(url).then(res => {
        this.tpsituacao = res.data.map(tpsituacao => {
          return {
            value: tpsituacao.id,
            text: `${tpsituacao.situacao}`
          }
        })
      })
    },
    loadJuridico () {
      const url = `${baseApiUrl}/assinatura-do-processo`
      axios.get(url).then(res => {
        this.juridico = res.data.map(juridico => {
          return {
            value: juridico.id,
            text: `${juridico.nome}`
          }
        })
      })
    },
    loadControle () {
      const url = `${baseApiUrl}/assinatura-do-processo`
      axios.get(url).then(res => {
        this.controle = res.data.map(controle => {
          return {
            value: controle.id,
            text: `${controle.nome}`
          }
        })
      })
    },
    loadAnexos () {
      const id = this.processo.proc_compra
      const url = `${baseApiUrl}/anexos-do-processo/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data
      })
    },
    loadAnexo (item, mode = 'update') {
      const url = `${baseApiUrl}/anexos-de-processos/${item.id}`
      axios.get(url).then(res => {
        this.anexo = res.data
      })
      this.mode = mode
      this.DialogAnexo = true
      this.loadTipoAnexo()
    },
    loadUsers () {
      this.processo.usuario = this.user.id
    },
    loadDatas () {
      this.mudaDataA()
      this.mudaDataB()
      this.mudaDataC()
      this.mudaDataD()
      this.mudaDataE()
      this.mudaDataF()
      this.mudaDataG()
      this.mudaDataI()
    },
    loadDispensa () {
      this.loadJuridico()
      this.loadControle()
      this.loadVeiculo()
      this.loadModalAcao()
      this.loadModalProcesso()
    },
    loadHomologacao () {
      this.loadSituacao()
    }
  },
  watch: {
    Filter () {
      this.loadFilter()
    }
  },
  mounted () {
    this.loadUsers()
    this.loadGestoes()
    this.loadTipo()
    this.loadModalidade()
    this.processo.uuid = uuid.v1()
  }
}
</script>

<style scoped>
.form-tabs {
  background-color: #f0eceaf3;
}

.text-v-card {
  font-size: 1rem !important;
}

.codigo {
  max-width: 100% !important;
}

.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}

.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}

.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}

.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}

ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}

ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}

ul.filtro li a:hover {
  color: #ffffff !important;
}

.logo-foto {
  max-width: 750px;
}
</style>
